(function () {
  'use strict';

  var configNode = document.getElementById('HcSearchConfig');
  if (!configNode) return;
  var cfg;
  try {
    cfg = JSON.parse(configNode.textContent);
  } catch (error) {
    return;
  }

  var CACHE_KEY = 'hcSearch:8:' + cfg.locale;
  var CACHE_MS = 30 * 60 * 1000;
  var GROUPS = ['panels', 'answers', 'policies', 'pages', 'conditions', 'articles'];
  var LIMITS = {
    box: { answers: 3, policies: 2, pages: 3, conditions: 4, panels: 4, articles: 3 },
    page: { answers: 20, policies: 10, pages: 20, conditions: 100, panels: 4, articles: 30 }
  };
  var QUOTE_OPEN = String.fromCharCode(8220);
  var QUOTE_CLOSE = String.fromCharCode(8221);
  var ARROW = String.fromCharCode(8594);
  var DOT = ' ' + String.fromCharCode(183) + ' ';
  var MARKS = new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g');
  var STOP = ['the', 'a', 'an', 'is', 'are', 'for', 'of', 'to', 'do', 'does', 'can', 'i', 'my', 'it', 'and', 'or', 'in', 'on', 'with', 'you', 'your', 'what', 'how', 'be', 'this', 'that', 'me', 'we', 'use', 'there', 'any', 'have', 'has', 'get', 'will', 'if', 'at', 'from', 'about', 'work', 'works', 'working', 'good', 'best', 'help', 'helps', 'need', 'long', 'much', 'many', 'take', 'takes', 'who', 'why', 'when', 'where', 'which', 'should', 'would', 'could', 'am', 'was', 'not', 'want', 'like', 'really', 'also', 'please', 'vs', 'versus', 'helio', 'cure', 'red', 'light', 'therapy'];
  var SYNONYMS = {
    refund: ['return'],
    money: ['return'],
    exchange: ['return'],
    delivery: ['shipping'],
    shipping: ['delivery'],
    ship: ['delivery'],
    deliver: ['shipping'],
    arrive: ['shipping', 'delivery'],
    postage: ['shipping'],
    guarantee: ['warranty', 'trial'],
    broken: ['warranty'],
    repair: ['warranty'],
    coupon: ['discount'],
    promo: ['discount'],
    code: ['discount'],
    voucher: ['discount'],
    veteran: ['military'],
    nurse: ['healthcare'],
    teacher: ['discount'],
    finance: ['financing', 'installment'],
    installment: ['financing'],
    monthly: ['financing', 'installment'],
    affirm: ['financing'],
    klarna: ['financing'],
    afterpay: ['financing'],
    payment: ['financing', 'pay'],
    cost: ['price'],
    cheap: ['price'],
    email: ['contact'],
    phone: ['contact'],
    call: ['contact'],
    chat: ['contact'],
    support: ['contact'],
    wrinkle: ['aging', 'skin'],
    face: ['skin'],
    sore: ['pain'],
    ache: ['pain'],
    safe: ['safety'],
    eye: ['eyes', 'eyewear'],
    goggle: ['eyewear'],
    glasses: ['eyewear'],
    size: ['dimensions', 'coverage'],
    compare: ['coverage'],
    lab: ['testing', 'tested'],
    eczema: ['dermatitis'],
    hsa: ['fsa'],
    fsa: ['hsa']
  };
  var MOST_ASKED = ['return', 'shipping', 'warranty', 'discount'];

  var entries = null;
  var pending = null;

  function own(map, key) {
    return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : null;
  }

  function fold(text) {
    var value = String(text || '').toLowerCase();
    if (value.normalize) value = value.normalize('NFD').replace(MARKS, '');
    return value.replace(/[^a-z0-9]+/g, ' ').replace(/(\d)([a-z])/g, '$1 $2').replace(/([a-z])(\d)/g, '$1 $2').trim();
  }

  function stem(word) {
    if (word.length >= 8 && /ing$/.test(word)) return word.slice(0, -3);
    if (word.length > 5 && /ed$/.test(word)) return word.slice(0, -2);
    if (word.length > 4 && /ies$/.test(word)) return word.slice(0, -3) + 'y';
    if (word.length > 3 && /s$/.test(word) && !/(ss|us|is)$/.test(word)) return word.slice(0, -1);
    return word;
  }

  function words(text) {
    var folded = fold(text);
    if (!folded) return [];
    var seen = Object.create(null);
    var list = [];
    folded.split(' ').forEach(function (word) {
      var stemmed = stem(word);
      if (!seen[stemmed]) {
        seen[stemmed] = true;
        list.push(stemmed);
      }
    });
    return list;
  }

  function plain(text) {
    var value = String(text || '');
    if (value.indexOf('&') === -1 && value.indexOf('<') === -1) return value.trim();
    var parsed = new DOMParser().parseFromString(value, 'text/html');
    return (parsed.body.textContent || '').trim();
  }

  function entry(group, title, url, text, meta, keys, hidden) {
    var cleanTitle = plain(title);
    var cleanText = plain(text);
    return {
      g: group,
      t: cleanTitle,
      u: url,
      x: cleanText,
      m: meta || '',
      ft: words(cleanTitle),
      fk: words(keys || ''),
      fx: words(cleanText + ' ' + plain(hidden || '')),
      folded: fold(cleanTitle)
    };
  }

  function build(raw) {
    var list = [];
    var seenUrl = Object.create(null);
    var summaries = Object.create(null);
    var otherNames = Object.create(null);
    (raw.conditions || []).forEach(function (item) {
      summaries[item.h] = item;
    });
    (raw.pages || []).forEach(function (item) {
      if (!item.u) return;
      otherNames[item.u] = (otherNames[item.u] || '') + ' ' + item.t;
    });
    (raw.faq || []).forEach(function (item) {
      if (!item.q || !item.a) return;
      list.push(entry('answers', item.q, cfg.faqUrl + '#:~:text=' + encodeURIComponent(plain(item.q)), item.a, '', ''));
    });
    (raw.policies || []).forEach(function (item) {
      if (!item.u || seenUrl[item.u]) return;
      seenUrl[item.u] = true;
      list.push(entry('policies', item.t, item.u, '', '', otherNames[item.u] || '', item.x));
    });
    (raw.pages || []).forEach(function (item) {
      var url = item.u || '';
      if (!url || url === '/' || url.charAt(0) !== '/' || item.o === 'search_link' || item.o === 'frontpage_link' || seenUrl[url]) return;
      seenUrl[url] = true;
      list.push(entry('pages', item.t, url, '', '', otherNames[url] || ''));
    });
    (raw.articles || []).forEach(function (item) {
      if (item.k === 'c') {
        var summary = summaries[item.h];
        if (!summary) return;
        var meta = '';
        if (summary.s !== '' && summary.s !== null && summary.s !== undefined) meta = cfg.words.score + ' ' + summary.s + ' / 100';
        if (summary.v) meta = meta ? meta + DOT + summary.v : summary.v;
        list.push(entry('conditions', summary.t || item.t, item.u, summary.x, meta, [summary.y, summary.g, item.t].join(' ')));
      } else {
        list.push(entry('articles', item.t, item.u, item.x, '', [item.g, item.y].join(' ')));
      }
    });
    (raw.panels || []).forEach(function (item) {
      var meta = [item.a, item.l, plain(item.p)].filter(Boolean).join(DOT);
      var panel = entry('panels', item.t, item.u, '', meta, ['panel device price buy shop size coverage', item.a, item.l, item.o, item.k].filter(Boolean).join(' '), item.d);
      if (typeof item.i === 'string' && /^(https:)?\/\//.test(item.i)) panel.i = item.i;
      list.push(panel);
    });
    return list;
  }

  function readCache() {
    try {
      var stored = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (stored && stored.at && Date.now() - stored.at < CACHE_MS && stored.raw) return stored.raw;
    } catch (error) {
      return null;
    }
    return null;
  }

  function writeCache(raw) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), raw: raw }));
    } catch (error) {
      return;
    }
  }

  function fetchDocument(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('status ' + response.status);
      return response.text();
    }).then(function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }

  function usable(data) {
    return !!(data && Array.isArray(data.articles) && data.articles.length);
  }

  function fetchIndex() {
    var inline = document.querySelector('script[data-hc-search-index]');
    if (inline) {
      try {
        var here = JSON.parse(inline.textContent);
        if (usable(here)) return Promise.resolve(here);
      } catch (error) {
        inline = null;
      }
    }
    return fetchDocument(cfg.indexUrl).then(function (parsed) {
      var node = parsed.querySelector('script[data-hc-search-index]');
      if (!node) throw new Error('no index');
      var data = JSON.parse(node.textContent);
      if (!usable(data)) throw new Error('empty index');
      return data;
    });
  }

  function fetchFaq() {
    return fetchDocument(cfg.faqUrl).then(function (parsed) {
      var list = [];
      parsed.querySelectorAll('script[type="application/ld+json"]').forEach(function (node) {
        var data;
        try {
          data = JSON.parse(node.textContent);
        } catch (error) {
          return;
        }
        (Array.isArray(data) ? data : [data]).forEach(function (block) {
          if (!block || block['@type'] !== 'FAQPage' || !Array.isArray(block.mainEntity)) return;
          block.mainEntity.forEach(function (question) {
            var answer = question && question.acceptedAnswer && question.acceptedAnswer.text;
            if (question && question.name && answer) list.push({ q: question.name, a: answer });
          });
        });
      });
      return list;
    }).catch(function () {
      return [];
    });
  }

  function retry(task, times, wait) {
    return task().catch(function (error) {
      if (times <= 0) throw error;
      return new Promise(function (resolve) {
        setTimeout(resolve, wait);
      }).then(function () {
        return retry(task, times - 1, wait * 2);
      });
    });
  }

  function load() {
    if (entries) return Promise.resolve(entries);
    if (pending) return pending;
    var cached = readCache();
    if (usable(cached)) {
      entries = build(cached);
      return Promise.resolve(entries);
    }
    pending = Promise.all([retry(fetchIndex, 2, 1500), fetchFaq()]).then(function (parts) {
      var raw = parts[0];
      raw.faq = parts[1];
      if (raw.faq.length) writeCache(raw);
      entries = build(raw);
      pending = null;
      return entries;
    }).catch(function () {
      pending = null;
      return [];
    });
    return pending;
  }

  function hits(token, list) {
    var best = 0;
    for (var i = 0; i < list.length; i += 1) {
      var word = list[i];
      if (word === token) return 1;
      if (token.length >= 3 && word.indexOf(token) === 0) best = Math.max(best, word.length - token.length <= 3 ? 0.9 : 0.3);
      else if (word.length >= 4 && token.indexOf(word) === 0 && token.length - word.length <= 2) best = Math.max(best, 0.9);
    }
    return best;
  }

  function near(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return false;
    var previous = [];
    var i;
    var j;
    for (j = 0; j <= b.length; j += 1) previous[j] = j;
    for (i = 1; i <= a.length; i += 1) {
      var current = [i];
      var best = current[0];
      for (j = 1; j <= b.length; j += 1) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        current[j] = Math.min(previous[j] + 1, current[j - 1] + 1, previous[j - 1] + cost);
        if (current[j] < best) best = current[j];
      }
      if (best > max) return false;
      previous = current;
    }
    return previous[b.length] <= max;
  }

  function fuzzy(token, list) {
    if (token.length < 5) return false;
    var max = token.length >= 8 ? 2 : 1;
    for (var i = 0; i < list.length; i += 1) {
      if (list[i].length >= 4 && near(token, list[i], max)) return true;
    }
    return false;
  }

  function weightOf(item, alternatives, loose) {
    var best = 0;
    alternatives.forEach(function (token, index) {
      var factor = index === 0 ? 1 : 0.7;
      if (loose) {
        if (fuzzy(token, item.ft) || fuzzy(token, item.fk)) best = Math.max(best, 2 * factor);
        return;
      }
      best = Math.max(best, 6 * factor * hits(token, item.ft), 4 * factor * hits(token, item.fk), 1.5 * factor * hits(token, item.fx));
    });
    return best;
  }

  function column(list, alternatives, loose) {
    return list.map(function (item) {
      return weightOf(item, alternatives, loose);
    });
  }

  function found(values) {
    return values.filter(function (value) { return value > 0; }).length;
  }

  function rank(list, tokens) {
    var total = list.length;
    var weights = tokens.map(function (alternatives) {
      var strict = column(list, alternatives, false);
      return found(strict) ? strict : column(list, alternatives, true);
    });
    var rarity = weights.map(function (values) {
      return Math.log(1 + total / (1 + found(values)));
    });
    var scored = [];
    list.forEach(function (item, index) {
      var score = 0;
      var matched = 0;
      tokens.forEach(function (alternatives, position) {
        var value = weights[position][index];
        if (value > 0) {
          matched += 1;
          score += value * rarity[position];
        }
      });
      if (matched) scored.push({ item: item, score: score * (matched / tokens.length), all: matched === tokens.length });
    });
    return scored;
  }

  function search(list, query) {
    var folded = fold(query);
    if (!folded) return [];
    var all = folded.split(' ');
    var kept = all.filter(function (word) { return STOP.indexOf(word) === -1; });
    if (!kept.length) kept = all;
    var tokens = kept.map(function (word) {
      var stemmed = stem(word);
      var alternatives = [stemmed];
      (own(SYNONYMS, stemmed) || own(SYNONYMS, word) || []).forEach(function (extra) {
        alternatives.push(stem(extra));
      });
      return alternatives;
    });
    var scored = rank(list, tokens);
    scored.forEach(function (row) {
      if (row.item.folded === folded) row.score += 6;
      else if (row.item.folded.indexOf(folded) !== -1) row.score += 3;
    });
    scored.sort(function (a, b) { return b.score - a.score; });
    var floor = scored.length ? scored[0].score * 0.4 : 0;
    var panelTop = 0;
    scored.forEach(function (row) { if (row.item.g === 'panels' && row.score > panelTop) panelTop = row.score; });
    var named = tokens.map(function (alternatives) { return alternatives[0]; });
    return scored.filter(function (row) {
      if (row.score >= floor) return true;
      if (row.item.g === 'panels' && row.all && panelTop >= floor) return true;
      return row.item.g === 'panels' && row.item.ft.some(function (word) { return word !== 'helio' && named.indexOf(word) !== -1; });
    }).map(function (row) { return row.item; });
  }

  function mostAsked(list) {
    var answers = list.filter(function (item) { return item.g === 'answers' && item.x; });
    var picked = [];
    MOST_ASKED.forEach(function (word) {
      var matches = search(answers, word).filter(function (item) { return picked.indexOf(item) === -1; });
      if (matches.length) picked.push(matches[0]);
    });
    return picked;
  }

  function node(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined && text !== null) element.textContent = text;
    return element;
  }

  function renderItem(item) {
    var link = node('a', 'hcs-item hcs-item--' + item.g);
    link.href = item.u;
    var body = link;
    if (item.i) {
      var image = node('img', 'hcs-item__img');
      image.src = item.i;
      image.alt = '';
      image.width = 64;
      image.height = 64;
      image.loading = 'lazy';
      link.className += ' hcs-item--media';
      link.appendChild(image);
      body = node('span', 'hcs-item__body');
      link.appendChild(body);
    }
    body.appendChild(node('span', 'hcs-item__title', item.t));
    if (item.m) body.appendChild(node('span', 'hcs-item__meta', item.m));
    if (item.x) body.appendChild(node('span', 'hcs-item__text', item.x));
    return link;
  }

  function renderGroup(title, items) {
    var section = node('div', 'hcs-group');
    section.appendChild(node('h2', 'hcs-group__title', title));
    items.forEach(function (item) {
      section.appendChild(renderItem(item));
    });
    return section;
  }

  function renderAsk(target) {
    var line = node('p', 'hcs-ask');
    if (cfg.words.askLead) line.appendChild(document.createTextNode(cfg.words.askLead + ' '));
    var link = node('a', 'hcs-ask__link', cfg.words.askLink + ' ' + ARROW);
    link.href = cfg.contactUrl;
    line.appendChild(link);
    target.appendChild(line);
  }

  function renderAll(target, trimmed) {
    var all = node('a', 'hcs-all', cfg.words.seeAll + ' ' + ARROW);
    all.href = cfg.searchUrl + '?q=' + encodeURIComponent(trimmed);
    target.appendChild(all);
  }

  function render(target, status, list, query, where) {
    while (target.firstChild) target.removeChild(target.firstChild);
    var trimmed = String(query || '').trim();
    var shown = 0;
    var said = '';
    if (!list.length) {
      if (where === 'box' && trimmed.length >= 2) renderAll(target, trimmed);
      else renderAsk(target);
      if (status) status.textContent = '';
      return 0;
    }
    if (trimmed.length >= 2) {
      var matches = search(list, trimmed);
      GROUPS.forEach(function (group) {
        var items = matches.filter(function (item) { return item.g === group; }).slice(0, LIMITS[where][group]);
        if (!items.length) return;
        shown += items.length;
        target.appendChild(renderGroup(cfg.words.groups[group], items));
      });
      if (shown) {
        said = shown + ' ' + cfg.words.count;
      } else if (trimmed.length >= 3) {
        said = cfg.words.none + ' ' + QUOTE_OPEN + trimmed + QUOTE_CLOSE;
        target.appendChild(node('p', 'hcs-none', said));
      }
    }
    if (!shown) {
      var asked = mostAsked(list);
      if (asked.length) target.appendChild(renderGroup(cfg.words.mostAsked, asked));
      if (trimmed.length >= 3) renderAsk(target);
    } else if (where === 'box') {
      renderAll(target, trimmed);
    }
    if (status) status.textContent = said;
    return shown;
  }

  function arrows(scope, input) {
    scope.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      var links = Array.prototype.slice.call(scope.querySelectorAll('a.hcs-item, a.hcs-all, a.hcs-ask__link'));
      if (!links.length) return;
      var index = links.indexOf(document.activeElement);
      event.preventDefault();
      if (event.key === 'ArrowDown') {
        links[Math.min(index + 1, links.length - 1)].focus();
      } else if (index <= 0) {
        input.focus();
      } else {
        links[index - 1].focus();
      }
    });
  }

  function wire(input, target, status, where, after) {
    var timer = null;
    function run() {
      var query = input.value;
      load().then(function (list) {
        if (input.value !== query) return;
        render(target, status, list, query, where);
        if (after) after(query);
      });
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 120);
    });
    target.addEventListener('touchstart', function () {
      if (document.activeElement === input) input.blur();
    }, { passive: true });
    run();
  }

  function setUpBox() {
    var dialog = document.getElementById('HcSearch');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var input = dialog.querySelector('.hcs__input');
    var target = dialog.querySelector('.hcs__results');
    var status = dialog.querySelector('.hcs__status');
    var wired = false;
    var opener = null;
    var pressed = null;

    function open(event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      opener = document.activeElement;
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('hcs-open');
      if (!wired) {
        wired = true;
        wire(input, target, status, 'box');
        arrows(dialog, input);
      }
      input.focus();
      input.select();
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('hcs-open');
      if (opener && typeof opener.focus === 'function') {
        try {
          opener.focus({ preventScroll: true });
        } catch (error) {
          opener.focus();
        }
      }
    });
    dialog.addEventListener('mousedown', function (event) {
      pressed = event.target;
    });
    dialog.addEventListener('click', function (event) {
      if (event.target.closest('[data-hc-search-close]') || event.target.closest('a')) {
        close();
        return;
      }
      if (event.target === dialog && (pressed === dialog || pressed === null)) close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      close();
    });
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-hc-search-open]');
      if (trigger) open(event);
    });
    ['pointerover', 'touchstart', 'focusin'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        if (event.target && event.target.closest && event.target.closest('[data-hc-search-open]')) load();
      }, { passive: true });
    });
  }

  function setUpPage() {
    var page = document.querySelector('[data-hc-search-page]');
    if (!page) return;
    var input = page.querySelector('.hcs-page__input');
    var target = page.querySelector('.hcs-page__results');
    var status = page.querySelector('.hcs__status');
    var heading = page.querySelector('.hcs-page__heading');
    if (!input || !target) return;
    wire(input, target, status, 'page', function (query) {
      var trimmed = String(query || '').trim();
      if (heading) heading.textContent = trimmed ? cfg.words.resultsFor + ' ' + QUOTE_OPEN + trimmed + QUOTE_CLOSE : cfg.words.title;
      try {
        var url = new URL(window.location.href);
        if (trimmed) url.searchParams.set('q', trimmed);
        else url.searchParams.delete('q');
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (error) {
        return;
      }
    });
    arrows(page, input);
  }

  function start() {
    setUpBox();
    setUpPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
